import { getParent, types } from 'mobx-state-tree';
import { createContext, useContext } from 'react';

import { CategoryStore, initialState as initialCategoryStore } from './filter';
import { ConfigStore, initialState as initialConfigStore } from './config';
import {
  FavouriteStore,
  initialState as initialFavouriteStore,
} from './favourites';
import { PoiStore, initialState as initialPoiStore } from './poi';
import { LayerStore } from './layers';
import { UserStore } from './user';
import { SearchStore, initialState as initialSearchStore } from './search';
import { Parking } from './parkopedia';
import {
  MyLocationsStore,
  initialState as initialMyLocationsStore,
} from './myLocations';
import { MobxParkopediaStore } from './parkopedia/parkopedia';

const StoreContext = createContext();

export const Provider = StoreContext.Provider;

export function useStore() {
  return useContext(StoreContext);
}

export const RootStoreModel = types.model({
  config: ConfigStore,
  poi: PoiStore,
  categories: CategoryStore,
  favourites: FavouriteStore,
  myLocations: MyLocationsStore,
  layers: LayerStore,
  user: UserStore,
  search: SearchStore,
  parking: Parking,
});

export const RootStore = RootStoreModel.create({
  config: initialConfigStore,
  poi: initialPoiStore,
  categories: initialCategoryStore,
  favourites: initialFavouriteStore,
  myLocations: initialMyLocationsStore,
  layers: {},
  user: {},
  search: initialSearchStore,
  parking: {
    parkopedia: MobxParkopediaStore.create(),
    selectedSpot: null,
  },
});

/**
 * allows hook free access (usable in any function) to stores
 * @param  {...string} stores store names as arguments, the function accepts any amount of arguments
 * @returns an object containing the requested stores
 */
export const getStores = (self, ...stores) =>
  Object.keys(getParent(self))
    .filter((key) => stores.includes(key))
    .reduce((map, key) => ({ ...map, [key]: getParent(self)[key] }), {});
